import { EventTypeInputExcludeTimeEventTypeMapBM } from '../types/BusinessModel/EventTypeInputExcludeTimeEventTypeMapBM';
import { EventTypeInputExcludeTimeEventTypeMap } from '../types/ViewModel/EventTypeInputExcludeTimeEventTypeMap';

export class EventTypeInputExcludeTimeEventTypeMapFactory {
    constructor() {}

    public newEventTypeInputExcludeTimeEventTypeMapList(
        evTypeExcludeEventListBM: EventTypeInputExcludeTimeEventTypeMapBM[]
    ): EventTypeInputExcludeTimeEventTypeMap[] {
        const evTypeExcludeFilterList: EventTypeInputExcludeTimeEventTypeMap[] = [];
        if (evTypeExcludeEventListBM && evTypeExcludeEventListBM.length > 0) {
            evTypeExcludeEventListBM.forEach((cmItem) => {
                evTypeExcludeFilterList.push(this.createEventTypeInputExcludeTimeEventTypeMapItem(cmItem));
            });
        }
        return evTypeExcludeFilterList;
    }

    private createEventTypeInputExcludeTimeEventTypeMapItem(item: EventTypeInputExcludeTimeEventTypeMapBM): EventTypeInputExcludeTimeEventTypeMap {
        return new EventTypeInputExcludeTimeEventTypeMap(
            item.eventTypeInputExcludeTimeEventTypeMapId,
            item.eventTypeId,
            item.fromEventTypeId,
            item.toEventTypeId
        );
    }
}
